var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7505 9.35027C29.9405 9.12799 30.2183 9 30.5107 9H42C42.5523 9 43 9.44772 43 10V41C43 41.5523 42.5523 42 42 42H8C7.44772 42 7 41.5523 7 41V14.3509C7 13.7986 7.44772 13.3509 8 13.3509H26.3311L29.7505 9.35027ZM30.9715 11L27.5521 15.0006C27.3621 15.2229 27.0843 15.3509 26.7919 15.3509H9V40H41V11H30.9715Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5205 28.0789C34.5205 23.6174 30.901 20 26.434 20C22.1276 20 18.6084 23.3624 18.3613 27.6019L20.8994 25.9752C21.3643 25.6771 21.9829 25.8125 22.2809 26.2775C22.5789 26.7424 22.4436 27.361 21.9786 27.659L17.4468 30.5636C16.982 30.8614 16.3639 30.7264 16.0656 30.2619L13.1586 25.7339C12.8603 25.2691 12.9951 24.6505 13.4599 24.3521C13.9246 24.0538 14.5433 24.1886 14.8416 24.6534L16.3968 27.0757C16.9007 21.9792 21.2031 18 26.434 18C32.0039 18 36.5205 22.5112 36.5205 28.0789C36.5205 33.6459 32.0039 38.1578 26.434 38.1578C24.6691 38.1578 23.0067 37.7036 21.5614 36.9054C21.0779 36.6384 20.9025 36.03 21.1695 35.5465C21.4365 35.0631 22.0449 34.8876 22.5283 35.1547C23.6851 35.7936 25.0159 36.1578 26.434 36.1578C30.9009 36.1578 34.5205 32.5398 34.5205 28.0789Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.1a8af7486d24a8aaedc38edea58334da.svg";
export { ForwardRef as ReactComponent };